import { jsx as o, jsxs as P, Fragment as b } from "react/jsx-runtime";
import { twMerge as r } from "tailwind-merge";
import { TooltipCustomButton as j, TooltipCustomDiv as z } from "./custom-button.mjs";
import { Popover as C, PopoverButton as E, Transition as L, PopoverPanel as O } from "@headlessui/react";
import { useRef as d, Fragment as R } from "react";
import { useIsOverflowText as B } from "../../hooks/use-is-overflow-text.mjs";
import { useWindowSize as D } from "../../hooks/use-window-size.mjs";
import { useFloatHover as H } from "../../hooks/use-float-hover.mjs";
const K = ({
  mode: e = "hover",
  popoverButtonRef: a,
  label: h,
  position: w = "top",
  anchor: x,
  className: y,
  wrapperClassName: g,
  popoverClassName: T,
  labelClassName: F,
  disabled: t,
  stayOnHover: s,
  children: n,
  hoverOpenDelay: k
}) => {
  const i = d(null), M = d(null), l = B(i), { width: N } = D(), { show: c, delayOpen: u, delayClose: f } = H({ hoverOpenDelay: k });
  return /* @__PURE__ */ o(C, { className: r("flex items-center", g), children: ({ open: p }) => {
    const m = t ? !1 : N < 1024 ? e === "overflow" && !l ? !1 : p : e === "click" ? p : e === "hover" || e === "overflow" && l ? c : !1;
    return /* @__PURE__ */ P(b, { children: [
      /* @__PURE__ */ o(
        E,
        {
          ref: (v) => {
            i && (i.current = v), a && (a.current = v);
          },
          as: e === "click" ? j : z,
          className: r(
            "relative truncate outline-hidden",
            e === "click" && !t && "cursor-pointer",
            "h-full w-full max-w-fit",
            y
          ),
          disabled: t,
          onMouseEnter: u,
          onMouseLeave: f,
          children: typeof n == "function" ? n(m) : n
        }
      ),
      /* @__PURE__ */ o(
        L,
        {
          as: R,
          show: m,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ o(
            O,
            {
              ref: M,
              anchor: x ?? w.replace("-", " "),
              className: r(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                T
              ),
              onMouseEnter: s ? u : void 0,
              onMouseLeave: s ? f : void 0,
              children: /* @__PURE__ */ o(
                "div",
                {
                  className: r(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    F
                  ),
                  children: h
                }
              )
            }
          )
        }
      )
    ] });
  } });
};
export {
  K as Tooltip
};
